// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__kji1y","colCheckbox":"styles_colCheckbox__2VZFX"};